import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useLocalStorageStore } from './localStorage.store';

interface SettingsStore {
	isNavigationBar: boolean;
	activeLanguage: string;
	accessedFrom: string;
	setNavigationBar: (show: boolean) => void;
	setActiveLanguage: (activeLanguage: string) => void;
	setAccessedFrom: (accessedFrom: string) => void;
}

const getActiveLanguage = () => {
	try {
		return useLocalStorageStore.getState().activeLang || 'HI';
	} catch {
		return 'HI';
	}
};

export const useSettingsStore = create<SettingsStore>()(
	persist(
		set => ({
			// Initial state
			isNavigationBar: false,
			activeLanguage: getActiveLanguage(),
			accessedFrom: 'web',

			// Actions
			setNavigationBar: (show: boolean) =>
				set(state => ({
					...state,
					isNavigationBar: show,
				})),

			setActiveLanguage: (activeLanguage: string) =>
				set(state => ({
					...state,
					activeLanguage,
				})),

			setAccessedFrom: (accessedFrom: string) =>
				set(state => ({
					...state,
					accessedFrom,
				})),
		}),
		{
			name: 'settings-store',
			partialize: state => ({
				activeLanguage: state.activeLanguage,
				accessedFrom: state.accessedFrom,
			}),
		},
	),
);
